// extracted by mini-css-extract-plugin
module.exports = {"optional":"style__optional__KosDS","label":"style__label__sWf-G"};